define('ip_popup', function () {
    var i18n = require('l10n');
    require("../../jquery-ui/jquery-ui.min.js");
    var url = "";
    var Collection = null;
    var showProgressBar = null;
    var hideProgressBar = null;
    var deleteBtn = null;
    var actionButton = null;
    var data = null;
    var type = null;

    var successMessage = null;
    var errorMessage = null;

    var templates = {
        "copy_link": require("text-loader!./templates/copy_link.html"),
        "confirm_delete": require("text-loader!./templates/confirm_delete.html"),
        "confirm_action": require("text-loader!./templates/confirm_action.html")
    };

    var methods = {
        "copy_link": function(element, title, link) {
            return copy_link(element, title, link);
        },
        "confirm_delete": function(element, title, content) {
            return confirm_delete(element, title, content);
        },
        "confirm_action": function(element, title, content) {
            return confirm_action(element, title, content);
        }
    };

    var element = $("<div id='popup_div'></div>");
    var show = function(title, content, templateName, options ) {

        var self = this;
        if ( $("#popup_div") )
            $("#popup_div").remove();

        var template = templates[templateName];

        if (template) {

            element.html(template);
            methods[templateName](element, title, content);

            $("body").append(element);

            url = options.url;
            Collection = options.collection;
            showProgressBar = options._showProgressBar;
            hideProgressBar = options._hideProgressBar;
            deleteBtn = options._deleteBtn;
            actionButton = options._actionButton;

            data = options.data;
            type = options.type;

            successMessage = options.successMessage;
            errorMessage = options.errorMessage;

            bind_events();
        }
    };

    var bind_events = function() {
        var self = this;

        $('#copy').off("click").on("click", function() {
            var copyText =  element.find(".popup-content input")[0];
            copyText.select();
            document.execCommand("copy");
            $(this).notify(i18n.t("queue.copy_success"), { position:"top right", className: "success" });
        });

        $('.popup-close').off("click").on("click", function() {
            if ( $("#popup_div") )
                $("#popup_div").remove();
        });

        /*
           use it as a check to ensure that if moving the mouse too quickly (and having it outside
           of the DRAGGED field), it will not change the cursor
        */
        var isMouseDown = false;
        /*    add 'dragging' class on drag and remove it afterwards    */
        $(".popup-top").off("mousedown mouseup mouseout").on("mousedown mouseup mouseout", function(e) {
            var $el = $("#popup_div .popup");

            switch(e.type) {
                case "mousedown":
                    isMouseDown = true;
                    $el.removeClass("grabbing").addClass("grabbing");

                    break;
                case "mouseup":
                    isMouseDown = false;
                    $el.removeClass("grabbing");

                    break;
                case "mouseout":
                    if(isMouseDown)
                        break;

                    isMouseDown = false;
                    $el.removeClass("grabbing");
                    break;
                default:

            }
        });

        $("#popup_div .popup").draggable({
            containment: "window",
            handle: ".popup-top",
            cancel: ".popup-close"
        });

        $('#deleteB').off("click").on("click", function() {
            showProgressBar();
            url = url;
            collection = Collection;

            $.ajaxDefaultQ({
                url: url,
                type: "DELETE",
                contentType: "application/json;charset=UTF-8",
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('X-CSRF-TOKEN', window.csrf);
                }
            }).done(function(response, status, xhr){
                self.totalCalls = self.totalCalls - 1;
                if(self.totalCalls == 0 &&self.callback && self.callback.success)
                    self.callback.success(response);

                collection.getFirstPage();
                deleteBtn.hide();
                hideProgressBar();
            })
            .fail(function(response) {
                self.totalCalls = self.totalCalls - 1;
                if(self.totalCalls == 0 &&self.callback && self.callback.success)
                    self.callback.success(response);

                hideProgressBar();
            });

            if ( $("#popup_div") )
                $("#popup_div").remove();
        });

        $('#cancelB').off("click").on("click", function() {
            if ( $("#popup_div") )
                $("#popup_div").remove();
        });

        $('#confirmB').off("click").on("click", function() {

            $.ajaxDefaultQ({
                url: url,
                type: type,
                data: data,
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('X-CSRF-TOKEN', window.csrf);
                },
                contentType: "application/json;charset=UTF-8"
            }).done(function(response, status, xhr){

                $('.popup-close').trigger("click");

                if(response.data && response.data == "OK") {
                    setTimeout(function() {
                        actionButton.notify(successMessage, { position:"top center", className: "success"});
                    }, 100);

                }
                else {
                    setTimeout(function() {
                        actionButton.notify(errorMessage, { position:"top center", className: "error"});
                    }, 100);
                }

            })
            .fail(function(response) {
                $('.popup-close').trigger("click");

                setTimeout(function() {
                    actionButton.notify(errorMessage, { position:"top center", className: "error"});
                }, 100);
            });

            if ( $("#popup_div") )
                $("#popup_div").remove();
        });
    };

    var copy_link = function (element, title, link) {
        $(element.find(".popup-title label")[0]).text(title);
        $(element.find(".popup-content input")[0]).val(link);
        $(element.find(".popup-content a")[0]).text( i18n.t("queue.monitor_page") );
        $(element.find(".popup-content a")[0]).prop('href', link);
        $(element.find(".copy_link ")[0]).text( i18n.t("queue.copy_link") );
        $(element.find(".visit_link ")[0]).text( i18n.t("queue.visit_link") );
    };

    var confirm_delete = function (element, title, content) {
        $(element.find(".popup-title label")[0]).text(title);
        $(element.find(".popup-content .delete_msg")[0]).text(content);
        $(element.find("#deleteB ")[0]).text( i18n.t("queue.delete") );
        $(element.find("#cancelB ")[0]).text( i18n.t("account.cancel") );
    };

    var confirm_action = function (element, title, content) {
        $(element.find(".popup-title label")[0]).text(title);
        $(element.find(".popup-content .confirm_msg")[0]).text(content);
        $(element.find("#confirmB")[0]).text( i18n.t("buttons.confirm") );
        $(element.find("#cancelB ")[0]).text( i18n.t("account.cancel") );
    };


    return {
        "show": show
    };
});